import 'whatwg-fetch';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import 'url-search-params-polyfill';
import { initInScope, onFind } from '@elements/init-modules-in-scope';
import { showNotification } from '@elements/alert-notification';
import { closest, on, findAll } from '@elements/dom-utils';
import {animatedTeaser, buttonLoading} from './utils';


const defaultOptions = {};

export function init(options = defaultOptions){
    for (const [key, value] of Object.entries({...defaultOptions, ...options})){
        defaultOptions[key] = value;
    }

    onFind('.js-image-grid__more', function(button){
        button.addEventListener('click', (e) => buttonClickHandler(button, e));
    });

    animatedTeaser(findAll('.js-image-grid__item.animated'));

}

function buttonClickHandler(button, e){
    const container = document.querySelector(button.getAttribute('data-target'));
    const buttonContainer = closest('.js-image-grid__more-container', button);
    buttonLoading(button, true);
    fetch(button.getAttribute('data-url'), {
        method:'POST',
        headers:{
            'X-Requested-With' : 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
        body:JSON.stringify({
            // page:parseInt(container.getAttribute('data-page') || 2),
            items:container.querySelectorAll('.js-image-grid__item').length
        })
    }).then((response) => response.json()).then(result => {
        buttonLoading(button, false);
        buttonContainer.remove();
        container.setAttribute('data-page', container.hasAttribute('data-page') ? (parseInt(container.getAttribute('data-page'))+1) : 3);
        container.insertAdjacentHTML('beforeend', result.html);
        if (typeof result.hasMore !== 'undefined' && !result.hasMore){
            button.remove();
        }
        setTimeout(function(){
            animatedTeaser(findAll('.js-image-grid__item.animated'));
        }, 50);
        initInScope(container);
    }).catch(error => {
        showNotification({
            type:'danger',
            title:_translations['error'],
            content:_translations['alert-notification.generic-error'],
            closable:true
        });
        buttonLoading(button, false);
    });
}